import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const useUserRole = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = Cookies.get("access_token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        // Adapte ce champ selon ta structure de JWT (parfois c'est 'role', 'label', 'roles', etc)
        const role = decodedToken.label || decodedToken.role || null;
        setUserRole(role);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, []);

  return userRole;
};

export default useUserRole;
